import { render, staticRenderFns } from "./TransferInfo.vue?vue&type=template&id=18f1d1f0&scoped=true"
import script from "./TransferInfo.vue?vue&type=script&lang=js"
export * from "./TransferInfo.vue?vue&type=script&lang=js"
import style0 from "./TransferInfo.vue?vue&type=style&index=0&id=18f1d1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1d1f0",
  null
  
)

export default component.exports